export default __webpack_public_path__ + "static/media/ever_logo.8c71ea29.7ea72395.png";